import React from 'react';
import { Link, useNavigate } from 'react-router';

import { OutlineArrowRight } from '../icons/outline-arrow-right';
import { AssetNameEditor } from '../../features/assets/components/asset-name-editor';

import styles from './breadcrumb.module.scss';

export type BreadcrumbObject = {
  href: string;
  label: string;
};

type BreadcrumbProps = {
  breadcrumbs: BreadcrumbObject[];
  /**
   * When provided, the last crumb becomes an inline-editable asset name.
   * Called with the new name when the user commits the edit.
   */
  onRenameLast?: (name: string) => void;
};

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ breadcrumbs, onRenameLast }) => {
  const navigate = useNavigate();

  const filteredBreadcrumbs =
    breadcrumbs.length > 3
      ? breadcrumbs.filter((_, index) => index >= breadcrumbs.length - 2)
      : breadcrumbs.slice(1);

  const firstBreadcrumb = breadcrumbs.length > 0 ? breadcrumbs[0] : null;

  return (
    <div className={styles.breadcrumb}>
      {firstBreadcrumb && (
        <>
          <Link
            className={styles.crumb}
            to={firstBreadcrumb.href}
          >
            {firstBreadcrumb.label}
          </Link>
          {breadcrumbs.length > 1 && <OutlineArrowRight />}
        </>
      )}
      {filteredBreadcrumbs.length < breadcrumbs.length - 1 && (
        <>
          <span>...</span>
          <OutlineArrowRight />
        </>
      )}

      {filteredBreadcrumbs.map(({ href, label }, index) => {
        const isLast = index === filteredBreadcrumbs.length - 1;

        return (
          <React.Fragment key={`${label}_${index}`}>
            <div
              className={styles.crumb}
              onClick={() => {
                if (isLast) return;
                navigate(href);
              }}
            >
              {isLast && onRenameLast ? (
                <AssetNameEditor name={label} onRename={onRenameLast} />
              ) : (
                label
              )}
            </div>
            {!isLast && <OutlineArrowRight />}
          </React.Fragment>
        );
      })}
    </div>
  );
};
